import { render, staticRenderFns } from "./MessageThreadList.vue?vue&type=template&id=2550615d"
import script from "./MessageThreadList.vue?vue&type=script&lang=js"
export * from "./MessageThreadList.vue?vue&type=script&lang=js"
import style0 from "./MessageThreadList.vue?vue&type=style&index=0&id=2550615d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports